<template>
    <div class="history">
        <ErrorBoundary>
            <div class="history_head">
                <div class="title">{{text('history.title')}}</div>
<!--                <DateRangePicker />-->
            </div>
            <WalletList />
            <Payment style="margin-bottom: 12px" />
            <div class="statistics_header">
                <div class="statistics_title">{{ text('history.statistics.title') }}</div>
                <div class="statistics_period">{{ text('history.statistics.period.current_month') }}</div>
            </div>
            <div class="statistics_list">
                <div v-if="statisticsLoading" class="statistics_empty">
                    {{ text('history.statistics.loading') }}
                </div>
                <div v-else-if="!statistics_list.length" class="statistics_empty">
                    {{ text('history.statistics.empty_current_month') }}
                </div>
                <template v-else>
                    <div v-for="(item, idx) in statistics_list" :key="idx" :class="`statistics_item ${this.color(item.wallet_transaction_type)}`">
                        <div>
                            <div class="amount">
                                <CurrencyAmount
                                    :currency-code="item.currency_code"
                                    :display-amount="formattedAmount(item)"
                                />
                            </div>
                            <div class="contition">{{this.name(item.wallet_transaction_type)}}</div>
                        </div>
                        <div class="count">{{formatCount(item.transaction_count)}}</div>
                    </div>
                </template>
            </div>
            <div class="main_line"></div>
            <TransactionsList />
        </ErrorBoundary>
    </div>
</template>

<script>
import WalletList from "@/components/WalletList.vue"
import Payment from '@/components/Payment.vue'
import TransactionsList from '@/components/transactions/TransactionsList.vue'
import DateRangePicker from '@/components/DateRangePicker.vue'
import ErrorBoundary from '@/components/ErrorBoundary.vue';
import CurrencyAmount from '@/components/base/CurrencyAmount.vue'


export default {
    name: "History",
    components: {
        ErrorBoundary,
        WalletList,
        Payment,
        TransactionsList,
        DateRangePicker,
        CurrencyAmount
    },
    computed: {
        authToken () {
            return this.$store.state.authToken
        },
        currentWallet () {
            return this.$store.state.currentWallet
        }
    },
    data () {
        return {
            statistics_list: [],
            statisticsLoading: false
        }
    },
    methods: {
        name(wallet_transaction_type) {
            const translationKey = `history.category.${wallet_transaction_type}`
            const translated = this.text(translationKey)
            return translated && translated !== translationKey
                ? translated
                : this.text('history.category.other')
        },
        color(wallet_transaction_type) {
            const colors = {
                topup: 'green',
                withdrawal: 'red',
                exchange: 'yellow',
            }
            return colors[wallet_transaction_type] || 'blue'
        },
        formattedAmount(item) {
            const amount = Number(item.amount)
            return Number.isFinite(amount)
                ? amount.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 4,
                })
                : item.amount
        },
        formatCount(count) {
            return this.text('history.statistics.operations_count').replace('{count}', count ?? 0)
        },
        async getWalletStat() {
            if (!this.currentWallet?.id || !this.authToken) {
                this.statistics_list = []
                return
            }
            this.statisticsLoading = true
            try {
                const { data } = await this.$http.get(
                    '/v2/wallet/stat',
                    {
                        params: {
                            account_id: this.currentWallet.id,
                        },
                        "headers": {
                            "Authorization": "Token " + this.authToken
                        }
                    }
                );
                this.statistics_list = data.results || [];
            } finally {
                this.statisticsLoading = false
            }
        },
        async getTransactionList() {
            const { data } = await this.$http.get(
                '/v2/wallet/stat',
                {
                    "headers": {
                        "Authorization": "Token " + this.authToken
                    }
                }
            );
            this.transactionList = data.results;
        },
    },
    watch: {
        currentWallet: {
            handler() {
                this.getWalletStat()
            },
            immediate: true
        }
    }
}
</script>

<style lang="scss" scoped>
  .history {
    padding: 24px;
  }
  .history .history_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0px 24px;
    margin-bottom: 32px;
  }
  .history .history_head .title {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 135%;
    letter-spacing: 0.4px;
  }
  .history .history_head .time {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .history .history_head .time span {
    color: #C7FF24;
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .history .statistics_header {
    display: flex;
    align-items: center;
    padding: 0 24px;
    justify-content: space-between;
    margin-bottom: 12px;
  }
  .history .statistics_title {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 135%;
  }
  .history .statistics_period {
    color: #C7FF24;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
  .history .statistics_list {
    padding: 0px 24px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 25px;
  }
  .history .statistics_list .statistics_item {
    width: calc(50% - 4px);
    border-radius: 8px;
    background: #3B363F;
    padding: 10px 8px 10px 12px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
  }
  .history .statistics_list .statistics_item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 3px;
    height: 100%;
  }
  .history .statistics_list .statistics_item .amount {
    color: #FFF;
    font-family: "Rubik", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    margin-bottom: 8px;
  }
  .history .statistics_list .statistics_item .contition {
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .history .statistics_list .statistics_item .count {
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
    white-space: nowrap;
  }
  .history .statistics_list .statistics_empty {
    width: 100%;
    border-radius: 8px;
    background: #3B363F;
    padding: 14px 12px;
    color: #A6A4B4;
    font-family: "Rubik", sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 135%;
  }
  .history .statistics_list .statistics_item.green::before {
    background: #00BF8E;
  }
  .history .statistics_list .statistics_item.red::before {
    background: #F34B47;
  }
  .history .statistics_list .statistics_item.yellow::before {
    background: #F4B52B;
  }
  .history .statistics_list .statistics_item.blue::before {
    background: #2C4A9B;
  }
  .history .main_line {
    border-radius: 10px;
    background: #312C35;
    height: 1px;
    width: calc(100% - 48px);
    margin: 0 auto 25px;
  }

  @media (max-width: 920px) {
    .history {
      border-radius: 16px;
      background: #262329;
      width: calc(100% - 40px);
      margin-left: 20px;
      padding-top: 16px;
    }
    .history .history_head {
      padding: 0 16px;
    }
    .history .history_head .title {
      font-size: 18px;
      letter-spacing: 0.36px;
    }
    .history .statistics_header {
      padding: 0px 16px;
      align-items: flex-start;
      flex-direction: column;
      gap: 4px;
    }
    .history .statistics_list {
      padding-left: 16px;
      padding-right: 16px;
    }
    .history .transaction_wrapper {
      margin: 0;
      padding: 0;
    }
    .history .transaction_wrapper .title {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .history {
      padding: 16px;
    }
  }



</style>
